import moment from "moment-timezone";

export const ALL_WALLET_CLIENTS = "__ALL__";

export const normalizeWalletClients = (value) => {
  const values = Array.isArray(value) ? value : String(value || "").split(",").filter(Boolean);
  if (values[values.length - 1] === ALL_WALLET_CLIENTS) return "";
  return values.filter((id) => id && id !== ALL_WALLET_CLIENTS).join(",");
};
export const validateWalletReportDates = (filters, instant = new Date()) => {
  const now = moment(instant).tz("Etc/GMT-3");
  const from = moment.tz(filters.dateFrom, moment.ISO_8601, true, "Etc/GMT-3");
  const to = moment.tz(filters.dateTo, moment.ISO_8601, true, "Etc/GMT-3");
  if (!from.isValid() || !to.isValid()) return "Select valid report dates";
  const earliest = now.clone().subtract(2, "months").startOf("day");
  const latest = now.clone().endOf("day");
  if ([from, to].some(date => date.isBefore(earliest) || date.isAfter(latest))) return "Date must be within the last 2 months (UTC+3)";
  const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(filters.dateTo);
  const time = /[T ]\d{2}:\d{2}(?::(\d{2})(\.\d+)?)?/.exec(filters.dateTo);
  const fullMinute = time && (!time[1] || time[1] === "00") && (!time[2] || Number(time[2]) === 0);
  const cutoff = filters.includeEodTotal || dateOnly
    ? to.clone().add(1, "day").startOf("day")
    : to.clone().add(fullMinute ? 60 : 0, "seconds");
  if (from.isSameOrAfter(cutoff)) return "Date From must not be after Date To";
  if (filters.includeEodTotal && cutoff.isAfter(now)) return "End-of-day totals require a completed broker day (UTC+3)";
  return "";
};

export const walletReportExportFormats = (filters) => (
  filters.reportType === "forex-deposit-details" && !normalizeWalletClients(filters.customerIds)
    ? ["csv"] : ["csv", "pdf", "xlsx"]
);
